import { connect } from "react-redux";
import CorporateList from "./corporateList";
import { bindActionCreators } from "redux";
import {
  getCorpClientList,
  deleteCorpClient,
  updateCorpClient,
} from "services/redux/brandActivtion/corporateClient/action";
const mapStateToProps = (state) => ({
  corpClientList: state.CorpClientReducer.corpClientList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCorpClientList,
      deleteCorpClient,
      updateCorpClient,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CorporateList);
